import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { SettingsView } from '@/features/settings/SettingsView';

export const Route = createFileRoute('/settings')({
  component: () => (
    <AppShell>
      <SettingsView />
    </AppShell>
  ),
});
